import { render, staticRenderFns } from "./user-permissions-table.vue?vue&type=template&id=3a29ec26&scoped=true"
import script from "./user-permissions-table.vue?vue&type=script&lang=js"
export * from "./user-permissions-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a29ec26",
  null
  
)

export default component.exports